<template>
    <div>
        <div class="sidebar-wrapper">
            <SideNav />
        </div>
        <div class="p-3">
            <div class="p-4 mt-2">
                <h4 class="title is-4 mb-1"> {{ getUser.name }} </h4>
                <h6 class="is-5 mb-2 has-text-weight- has-text-grey is-7">{{ getUser.phone.countryCode+getUser.phone.tel }}</h6>
                <b-tag type="is-primary"> {{ getUser.type }} </b-tag>
            </div>
            <div v-if="false" class="p-3">
                <div class="card p-5">
                    <div class="columns is-mobile">
                        <div class="column is-6">
                            <p class="title is-5"> Wallet </p>
                            <h4 class="subtitle is-5">Total </h4>
                        </div>
                        <div class="column is-flex is-align-items-center is-justify-content-right	">
                            <h4 class="has-text-weight-medium">GHC{{ getTotals(completed).toFixed(2) }}</h4>
                        </div>
                    </div>
                    <hr class="mt-3">
                    <div class="columns is-mobile">
                        <div class="column is-half">
                            <div class="">
                                <p class="title is-5"> Pay Outs </p>
                                <h4 class="subtitle is-5">GHC0.00</h4>
                            </div>
                        </div>
                        <div class="column is-flex is-justify-content-right">
                            <div class=" ">
                                <p class="title is-5"> Pay Ins </p>
                                <h4 class="subtitle is-5">GHC0.00</h4>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="p-3">
                <div class="card p-5">
                    <div class="columns is-mobile">
                        <div class="column is-6">
                            <p class="title is-4 has-text-primary"> Today</p>
                            <h4 class="subtitle is-5 mb-0">Today's Earnings </h4>
                        </div>
                        <div class="column is-flex is-align-items-center is-justify-content-right">
                            <h4 class="has-text-weight-medium title is-6"> {{ numFormat(getTodayTotals(completed)) }} </h4>
                            
                        </div>
                    </div>
                </div>
            </div>
            <div class="p-3">
                <div class="card p-5">
                    <div class="columns is-mobile">
                        <div class="column is-6">
                            <p class="title is-4 has-text-primary"> This Month</p>
                            <h4 class="subtitle is-5 mb-0">{{ (new Date()).toDateString().substr(4,3) }}'s Earnings </h4>
                        </div>
                        <div class="column is-flex is-align-items-center is-justify-content-right">
                            <h4 class="has-text-weight-medium title is-6"> {{ numFormat(getMonthTotals(completed)) }} </h4>
                            
                        </div>
                    </div>
                </div>
            </div>
            <div class="p-3">
                <div class="card p-5">
                    <div class="columns is-mobile">
                        <div class="column is-6">
                            <p class="title is-4 has-text-primary"> Wallet</p>
                            <h4 class="subtitle is-5 mb-0">Total Earnings </h4>
                        </div>
                        <div class="column is-flex is-align-items-center is-justify-content-right">
                            <h4 class="has-text-weight-medium title is-6 "> {{ numFormat(getTotals(completed)) }} </h4>
                            
                        </div>
                    </div>
                </div>
            </div>
            <div class="p-3">
                <div class="card p-5">
                    <div class="columns is-mobile">
                        <div class="column is-6">
                            <p class="title is-4 has-text-"> Balance</p>
                            <h4 class="subtitle is-5">Total Balance</h4>
                        </div>
                        <div class="column is-flex is-align-items-center is-justify-content-right	">
                            <h4 class="has-text-weight-medium title is-6"> {{ getUser.payOuts ? numFormat(getTotals(completed) - getUser.payOuts.reduce((a, b) => a + b.amount, 0)) : numFormat(getTotals(completed)) }} </h4>
                        </div>
                    </div>
                </div>
            </div>
            <div class="p-3">
                <div class="card p-5">
                    <div class="columns is-mobile">
                        <div class="column is-6">
                            <p class="title is-4 has-text-primary"> Pay outs</p>
                            <h4 class="subtitle is-5">Total payouts</h4>
                            <b-tag @click="$buefy.toast.open('Kindly contact Admin: Shopnscan')" type="is-primary">Request Payout </b-tag>
                        </div>
                        <div class="column is-flex is-align-items-center is-justify-content-right	">
                            <h4 class="has-text-weight-medium title is-6"> {{ getUser.payOuts ? numFormat(getUser.payOuts.reduce((a, b) => a + b.amount, 0)) : numFormat(0) }}</h4>
                        </div>
                    </div>
                </div>
            </div>


        </div>
        
        <!-- <MainFooter/> -->
    </div>
</template>

<script>

            
    import { mapGetters, mapActions} from 'vuex'

    import MainFooter from '../components/footer'
    import SideNav from '../components/sidenav'

    import wNumb from 'wnumb'

    export default {
        data(){ return { 
            format: wNumb({ decimals: 2, thousand: ",", prefix: '₵ ', }),
        }},
        name: "EarningsPage",
        components: {
            // MainFooter,
            SideNav,
        },
        computed: {

            ...mapGetters('auth', ['getUser']),
            ...mapGetters('orders', ['getOrders']),
            ...mapGetters('orders', ['pending']),
            ...mapGetters('orders', ['confirmed']),
            ...mapGetters('orders', ['completed']),
            ...mapGetters('orders', ['cancelled']),
            
        },
        mounted() {
            //
            this.getAllOrders()
        },
        methods: {
            numFormat(amt){
                return this.format.to(amt)
            },
            getTotals(obj){
               const sum  = obj. reduce((accumulator, object) => {
                    return accumulator + object.payAmount;
                }, 0)

                return sum
            },
            getTodayTotals(obj){
               const sum  = obj.filter(o=> new Date().toJSON().substring(0, 10) == o.orderDelivered.substring(0, 10) ).reduce((accumulator, object) => {
                    return accumulator + object.payAmount;
                }, 0)

                return sum
            },
            getMonthTotals(obj){
               const sum  = obj.filter(o=> new Date().toJSON().substring(0, 7) == o.orderDelivered.substring(0, 7) ).reduce((accumulator, object) => {
                    return accumulator + object.payAmount;
                }, 0)

                return sum
            },
            alert(){
                console.log(this.$route)
            },
            async getAllOrders() {

                await this.$store.dispatch('orders/getOrders')
                // x = wNumb({ decimals: 2, thousand: ",", prefix: '$ ', })
            }
        }
    }
</script>

<style lang="scss" scoped>
    // .card {
    //     border: 1px solid rgba(10, 10, 10, 0.1) !important;
    //     box-shadow: none;
    // }
</style>